import { classNames } from "../../utils/helperFuctions";

const SimpleHeading = ({
  label,
  handleheaderActionClick,
  headerAction,
  reservationCode,
  showReservationCodeAndStatus,
  fields,
  secondValueNextToCode,
}) => {
  const value =
    secondValueNextToCode != null
      ? fields.find((field) => field.name === secondValueNextToCode)
          .defaultValue
      : undefined;
  return (
    <div className="border-b border-gray-200 bg-gray-100 px-4 py-5 sm:px-6 rounded-t-lg">
      <div className="-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap">
        <div className=" ml-4 mt-2 w-full flex justify-between">
          <h3 className="text-base font-semibold flex items-center text-gray-700">
            {label}
          </h3>
          {showReservationCodeAndStatus === true && (
            <h3 className="flex items-center text-sm  ">
              <div>{reservationCode}</div>
              {value != null && (
                <>
                  <div className="mx-1">|</div>
                  <div>{value}</div>
                </>
              )}
            </h3>
          )}
        </div>
        <div className="ml-2 mt-2 flex-shrink-0">
          <button
            type="button"
            onClick={handleheaderActionClick}
            name={headerAction?.id}
            className={classNames(
              headerAction ? "" : "hidden",
              "relative inline-flex items-center rounded-md bg-purple-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-700"
            )}
          >
            {headerAction?.name}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleHeading;
